import studentCareerPathService from "../../apiServices/student/studentCareerPathService";
import { setJobDescription, setStudentCurrentOpening } from "../../store/slices/student/studentCurrentOpeningSlice";

export function getStudentCurrentOpeningDetails(pageNumber: number, keyword?: string) {
  return async function (dispatch: any, getState: any) {
    let response = await studentCareerPathService.getCurrentOpenings(pageNumber, keyword)
    if (response?.success === true) {
      dispatch(setStudentCurrentOpening(response.data));
    } else {
      console.log("error");
    }
  };
}

export function getJobDescription(jobCode: string) {
  return async function (dispatch: any, getState: any) {
    let response = await studentCareerPathService.getJobDescription(jobCode)
    if (response?.success === true) {
      dispatch(setJobDescription(response.data));
    } else {
      console.log("error");
    }
  };
}